import Modal from "~/components/Modal";
import { ModalController } from "~/util/hooks";
import { VErrors } from "~/validation";

const HelpModal = ({
  controller,
  errors,
}: {
  controller: ModalController;
  errors: VErrors<any>;
}) => {
  type T = Map<any, T | Array<string>>;
  const renderSubMap = (map: T) => {
    const ve = Array.from(map.entries());
    return (
      <ul>
        {ve.map(([fieldName, subMapOrList]) => {
          if (subMapOrList instanceof Map) {
            return <li key={String(fieldName)}>{renderSubMap(subMapOrList)}</li>;
          }
          return (
            <li key={String(fieldName)}>
              <ul>
                {(subMapOrList as Array<string>).map((reason, idx) => {
                  return (
                    <li key={idx} className="mb-2 [color:var(--support-01)] text-dec-circle ml-6">
                      <span className="text-sm">{reason}</span>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
    );
  };
  return (
    <Modal
      open={controller.shown}
      modalHeading="Submit requirements"
      modalLabel="Upload"
      onRequestClose={controller.close}
      modalFooter={() => <></>}
    >
      <div className="text-sm mb-4">These are the requirements you haven't met:</div>
      {renderSubMap(errors)}
    </Modal>
  );
};

export default HelpModal;
